import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'split-action-confirm-modal',
  templateUrl: './split-action-confirm-modal.component.html',
  styleUrls: ['./split-action-confirm-modal.component.scss']
})
export class SplitActionConfirmModalComponent {
  @Input() isVisible: boolean = false
  @Input() isLoading: boolean = false
  @Input() action: string = ''
  @Output() onClose = new EventEmitter<string>();
  @Output() onConfirm = new EventEmitter<string>();


  protected dynamicDialogRef!: DynamicDialogRef

  onEmitClose(){
    this.onClose.emit()
  }

  onEmitConfirmation(){
    this.onConfirm.emit(this.action)
  }
}
